import { NotificationsResponse } from '@src/types/graphql-types'
import NoResults from './NoResults'
import NotificationItem from './NotificationItem'
import NotificationsWrapper from './NotificationsWrapper'

interface NotificationCenterProps {
  data: NotificationsResponse[]
}

const NotificationCenter: React.FC<NotificationCenterProps> = ({ data }) => {
  if (data?.length === 0) {
    return (
      <NotificationsWrapper notifications={data}>
        <NoResults />
      </NotificationsWrapper>
    )
  }

  return (
    <NotificationsWrapper notifications={data}>
      {data?.map((v, i: number) => (
        <NotificationItem
          key={i}
          notificationType={v.notificationType}
          orderNumber={v.orderNumber}
          eventDate={v.eventDate}
        />
      ))}
    </NotificationsWrapper>
  )
}

export default NotificationCenter
